<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <v-img
          :src="require('@/assets/images/logos/logo.png')"
          max-height="60px"
          max-width="60px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h1 class="app-title text--primary">Si WALI/ORTU</h1>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <nav-menu-section-title title="MENU ORTU"></nav-menu-section-title>
    <v-list expand shaped class="vertical-nav-menu-items pr-5">
      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Dashboard"
        :to="{ name: 'orangTua-dashboard' }"
        :icon="icons.mdiHome"
      ></nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Panduan"
        :to="{ name: 'panduan-index' }"
        :icon="icons.mdiBookAlert"
      ></nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Profil"
        :to="{ name: 'profil-index' }"
        :icon="icons.mdiAccount"
      ></nav-menu-link>
      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Nilai Studi Persemester"
        :to="{ name: 'kartuhasilstudi-index' }"
        :icon="icons.mdiCardAccountDetailsStar"
      ></nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Transkrip Nilai"
        :to="{ name: 'transkripnilai-index' }"
        :icon="icons.mdiAlphaTBox"
      ></nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Rekap Presensi"
        :to="{ name: 'rekappresensi-index' }"
        :icon="icons.mdiTable"
      >
      </nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Info Pembayaran/Tagihan"
        :to="{ name: 'info-pembayaran-index' }"
        :icon="icons.mdiCashMultiple"
      >
      </nav-menu-link>

      <nav-menu-link
        v-if="dataOrtu == 4"
        title="Mengubah Password"
        :to="{ name: 'ubah-password' }"
        :icon="icons.mdiArchive"
      >
      </nav-menu-link>

      <div v-if="dataOrtu == 4">
        <a @click="getLogout()">
          <nav-menu-link title="Logout" :icon="icons.mdiLogout"></nav-menu-link>
        </a>
      </div>
    </v-list>

    <!-- <a href="https://themeselection.com/products/materio-vuetify-vuejs-admin-template" target="_blank" rel="nofollow">
      <v-img
        :src="require(`@/assets/images/pro/upgrade-banner-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
        alt="upgrade-banner"
        transition="scale-transition"
        class="upgrade-banner mx-auto"
        max-width="230"
      ></v-img>
    </a> -->
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHome,
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiArchive,
  mdiCashMultiple,
  mdiCardAccountDetailsStar,
  mdiWeb,
  mdiStoreSettings,
  mdiMapMarkerPath,
  mdiBookAlert,
  mdiAccount,
  mdiClipboardList,
  mdiCardAccountDetails,
  mdiAlphaTBox,
  mdiBarcodeScan,
  mdiLogout,
  mdiTimelineCheck,
  mdiBookEducation,
  mdiBookEducationOutline,
  mdiAccountGroup,
  mdiFileCheckOutline,
  mdiInvoiceListOutline,

} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHome,
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiArchive,
        mdiCashMultiple,
        mdiCardAccountDetailsStar,
        mdiWeb,
        mdiStoreSettings,
        mdiMapMarkerPath,
        mdiBookAlert,
        mdiAccount,
        mdiClipboardList,
        mdiCardAccountDetails,
        mdiAlphaTBox,
        mdiBarcodeScan,
        mdiLogout,
        mdiTimelineCheck,
        mdiBookEducation,
        mdiBookEducationOutline,
        mdiAccountGroup,
        mdiFileCheckOutline,
        mdiInvoiceListOutline,

      },

      datadosen: '',
      dataOrtu: '',
    }
  },
  created() {
    this.$isLoading(true)

    setTimeout(() => {
      this.getOrtu()
      this.$isLoading(false)
    }, 500)
  },
  methods: {
    getLogout() {
      // console.log("LOGOUT");
      this.$isLoading(true) // show loading screen
      let uri = process.env.VUE_APP_ROOT_API + '/api/auth/logout'
      this.axios
        .post(uri, {
          token: this.token,
        })
        .then(response => {
          // this.msg = response.data
          // if (this.msg == "success") {
          localStorage.removeItem('token')
          this.$swal.fire({
            title: 'Success',
            text: 'Logout successfully',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,
          })
        })
      // window.location.reload(true)
      this.$router.push('/')
      setTimeout(() => {
        this.$isLoading(false)
      }, 2000)
    },

    getOrtu() {
     /* let uriOrtu = process.env.VUE_APP_ROOT_API + '/api/ortu/profile/auth-info'
      return this.axios.get(uriOrtu).then(response => {
        this.dataOrtu = response.data.data.id
         console.log('ROLE MAHASISWA xxxxxxxxxxxxxxxxx: ' +this.dataOrtu)
      })*/
     this.dataOrtu="4"
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
